module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0069.png.3bb21495.jpg";